import React from 'react';
import { sdkRequest } from 'js-utils/http';

export const _loadOrganizationEffect = async ({
    setOrganization,
    organizationId,
    usesNewPermissions,
}) => {
    if (!organizationId || !usesNewPermissions) {
        setOrganization();
        return;
    }

    setOrganization(
        await sdkRequest(
            `/api/v3/organizations/${organizationId}?expand=image`,
        ),
    );
};

export const LoadOrganization = (props) => {
    const { organizationId, usesNewPermissions } = props;
    const [organization, setOrganization] = React.useState();

    React.useEffect(() => {
        _loadOrganizationEffect({
            setOrganization,
            organizationId,
            usesNewPermissions,
        });
    }, [organizationId, usesNewPermissions]);

    return props.children(organization);
};
